import * as Yup from "yup";
import Alert from "../../utils/Alert.js";
import { addNewDiscountService, editDiscountService } from "../../services/discountsServices.js";
import { convertDateToGregorian } from "../../utils/convertDate.js";

export const initialValues = {
    title: "",
    code: "",
    coupon_type: "p",
    amount: "",
    percent: "",
    start_date: "",
    end_date: "",
    min_spend: "",
    max_discount: "",
    is_active: true
};

export const initialTouched = {
    title: true,
    code: true,
    coupon_type: true,
    amount: true,
    percent: true,
    start_date: true,
    end_date: true,
    min_spend: true,
    max_discount: true,
    is_active: true
};

export const onSubmit = async (values, actions, editingDiscount, setDiscounts, navigate) => {
    const data = {
        ...values,
        start_date: convertDateToGregorian(values.start_date),
        end_date: convertDateToGregorian(values.end_date),
    };
    const { amount, ...dataWithPercent } = data;
    const { percent, ...dataWithAmount } = data;
    const finalData = values.coupon_type === "p" ? dataWithPercent : dataWithAmount;

    try {
        if (editingDiscount) {
            const response = await editDiscountService(editingDiscount.code, finalData);
            if (response.status === 200) {
                setDiscounts(prevDiscounts => prevDiscounts.map(d => {
                    if (d.code === editingDiscount.code) {
                        return response.data;
                    }
                    return d;
                }))
                await Alert("انجام عملیات", "تخفیف با موفقیت ویرایش شد", "success");
                return navigate(-1);
            }
        } else {
            const response = await addNewDiscountService(finalData);
            if (response.status === 200) {
                setDiscounts(prevDiscounts => [...prevDiscounts, response.data]);
                Alert("انجام عملیات", "تخفیف با موفقیت ایجاد شد", "success");
                actions.resetForm();
            }
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            Alert(`خطا ${error.response.status}!`, "این کد تخفیف در حال حاضر وجود دارد.", "error");
        }
    }
};

export const validationSchema = Yup.object().shape({
    title: Yup.string().required("لطفاً عنوان تخفیف را وارد کنید")
        .matches(/^[a-zA-Z\u0600-\u06FF\u200c\s0-9]+$/, "فقط از حروف الفبای فارسی یا انگلیسی استفاده شود"),
    code: Yup.string().required("لطفاً کد تخفیف را وارد کنید")
        .max(16, "کد تخفیف حداکثر 16 رقمی است")
        .matches(/^[a-zA-Z0-9]+$/, "فقط از اعداد و الفبای انگلیسی استفاده شود"),
    coupon_type: Yup.string().required("لطفاً یک حالت را انتخاب کنید"),
    amount: Yup.number().when("coupon_type", {
        is: "a",
        then: (schema) => schema.required("لطفاً مبلغ تخفیف را وارد کنید")
            .typeError("لطفاً فقط عدد وارد کنید")
            .min(1, "مبلغ تخفیف نمیتواند 0 یا منفی باشد")
    }),
    percent: Yup.number().when("coupon_type", {
        is: "p",
        then: (schema) => schema.required("لطفاً درصد تخفیف را وارد کنید")
            .typeError("لطفاً فقط عدد وارد کنید")
            .min(1, "درصد تخفیف نمیتواند 0 باشد")
            .max(100, "درصد تخفیف نمیتواند از 100 بیشتر باشد")
    }),
    start_date: Yup.string().required("لطفاً تاریخ شروع پایان را مشخص کنید"),
    end_date: Yup.string().required("لطفاً تاریخ شروع تخفیف را مشخص کنید"),
    min_spend: Yup.number().typeError("لطفاً فقط عدد وارد کنید")
        .required("لطفاً حداقل مبلغ را مشخص کنید")
        .min(0, "حداقل مبلغ نمیتواند منفی باشد"),
    max_discount: Yup.number().typeError("لطفاً فقط عدد وارد کنید")
        .required("لطفاً حداکثر تخفیف را مشخص کنید")
        .min(1, "حداکثر تخفیف نمیتواند 0 باشد"),
    is_active: Yup.boolean()
});


